// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"d55e352a","496":"dd1440aa","576":"116acd20","611":"0031fd45","829":"b0f2e534"}[chunkId] + ".chunk.js";
};